export function isAgentWorkspace() {
  return location.pathname === "/agent" || location.pathname.startsWith("/agent/");
}

export async function workspaceServiceWorker(staff = isAgentWorkspace()) {
  if (!("serviceWorker" in navigator)) throw new Error("Service workers are not supported.");
  const registration = await navigator.serviceWorker.register(
    staff ? "/sw.js?workspace=agent" : "/sw.js",
    { scope: staff ? "/agent/" : "/" },
  );
  if (registration.active) return registration;
  await new Promise<void>((resolve, reject) => {
    const timeout = window.setTimeout(() => { cleanup(); reject(new Error("Web app setup timed out. Reload and try again.")); }, 20000);
    const worker = registration.installing || registration.waiting;
    const cleanup = () => { clearTimeout(timeout); worker?.removeEventListener("statechange", changed); };
    const changed = () => {
      if (registration.active) { cleanup(); resolve(); }
      else if (worker?.state === "redundant") { cleanup(); reject(new Error("Web app setup failed. Reload and try again.")); }
    };
    worker?.addEventListener("statechange", changed);
    changed();
  });
  return registration;
}

export function registerSupportServiceWorker() {
  if (!("serviceWorker" in navigator) || !import.meta.env.PROD) return;
  const register = () => void workspaceServiceWorker().catch((error) => console.warn("Support service worker registration failed", error));
  if (document.readyState === "complete") register();
  else window.addEventListener("load", register, { once: true });
}
